import { Routes } from "@angular/router";
import { NewsSettingRoutePaths } from "@app/shared/news/news-setting-route-paths";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@shared/general/translation/constants/translation.constant";

export const newsSettingRoutes: Routes = [
  {
    path: NewsSettingRoutePaths.TAG,
    loadChildren: () => import("./domains/tag/tag.routing").then(r => r.tagRoutes),
    resolve: {
      translate: loadTranslationResolver(TRANSLATION_PATHS.NEWS.TAG),
    },
  },
  {
    path: NewsSettingRoutePaths.CATEGORY,
    loadChildren: () => import("./domains/category/category.routing").then(r => r.categoryRoutes),
    resolve: {
      translate: loadTranslationResolver(TRANSLATION_PATHS.NEWS.CATEGORY),
    },
  },
];
